"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ebSysAccountPortRoleAuthSaveInfo = ebSysAccountPortRoleAuthSaveInfo;
exports.getCancel = getCancel;
exports.queryAuthenticationEdit = queryAuthenticationEdit;
exports.queryClause = queryClause;
exports.queryInfoRoleList = queryInfoRoleList;
exports.queryListInfo = queryListInfo;
exports.submit = submit;
var _request = _interopRequireDefault(require("@/utils/request"));
//查询
function queryListInfo(listQuery) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/queryListInfo' + "?currentPage=" + listQuery.currentPage + "&" + "pageSize=" + listQuery.pageSize,
    method: 'get'
  });
}
//前台权限认证申请记录提交查看认证编辑功能
function queryAuthenticationEdit() {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/queryAuthenticationEdit',
    method: 'post'
  });
}

//提交
function submit(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/submit',
    method: 'post',
    data: data
  });
}

//查询角色
function queryInfoRoleList() {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/queryInfoRoleList',
    method: 'get'
  });
}
//条款和须知
function queryClause() {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/queryClause',
    method: 'get'
  });
}
//保存
function ebSysAccountPortRoleAuthSaveInfo(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/saveInfo',
    method: 'post',
    data: data
  });
}
//作废
function getCancel(officeRoleAuthId) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountPortRoleAuth/cancel/' + officeRoleAuthId,
    method: 'post'
  });
}